import { styled, theme, uiCommon } from '../../lib'

export const StyledButtonGroupButton = styled('button', {
  ...uiCommon.buttonReset,
  fontSize: theme.sizes.ui_12,
  fontFamily: theme.fonts.ui_mono,
  lineHeight: 1,
  height: `100%`,
  borderTop: `1px solid ${theme.colors.mauve5}`,
  borderRight: `1px solid ${theme.colors.mauve5}`,
  borderBottom: `1px solid ${theme.colors.mauve5}`,

  '&:first-of-type': {
    borderRadius: `${theme.sizes.ui_04} 0 0 ${theme.sizes.ui_04}`,
    borderLeft: `1px solid ${theme.colors.mauve5}`
  },

  '&:last-of-type': {
    borderRadius: `0 ${theme.sizes.ui_04} ${theme.sizes.ui_04} 0`
  },

  variants: {
    isActive: {
      true: {
        backgroundColor: theme.colors.mauve3,
        color: theme.colors.mauve12
      },
      false: {
        color: theme.colors.mauve9,
        '&:hover': {
          color: theme.colors.mauve12
        }
      }
    },
    size: {
      small: {},
      medium: {}
    }
  }
})

export const StyledButtonGroup = styled('div', {
  display: 'flex',
  flexWrap: 'nowrap',

  variants: {
    size: {
      small: {
        height: theme.sizes.ui_28,

        [`& ${StyledButtonGroupButton}`]: {
          padding: `0 ${theme.sizes.ui_12}`
        }
      },
      medium: {
        height: theme.sizes.ui_40,

        [`& ${StyledButtonGroupButton}`]: {
          padding: `0 ${theme.sizes.ui_16}`
        }
      }
    }
  }
})
